import React from "react";
import successSvg from "../assets/success.svg";
import failureSvg from "../assets/failure.svg";

export type ResultHeaderProps = {
  children?: React.ReactNode;
  status?: "success" | "failure";
};

export const ResultHeader = ({
  children,
  status = "success",
}: ResultHeaderProps) => {
  return (
    <div className={`gpc__result-header ${status}`}>
      <h3>{children}</h3>
      {status === "success" && <img src={successSvg} />}
      {status === "failure" && <img src={failureSvg} />}
    </div>
  );
};
